import { GmailDeletionModel } from '../../../../../types';
import { searchOptions } from '../gmail-deletion-form-page';
import SharedReviewLayout, {
  ReviewSection,
} from '../../../../shared/shared-review-layout';

interface StepReviewProps {
  selectedGmailDeletion: GmailDeletionModel;
}

export default function StepReview({ selectedGmailDeletion }: StepReviewProps) {
  const sections: ReviewSection[] = [
    {
      title: 'Search Configuration',
      leftItems: [
        {
          label: 'Search',
          value:
            searchOptions.find(
              (o) => o.value === selectedGmailDeletion.whereToSearch
            )?.displayValue || 'Unknown',
        },
        { label: 'From', value: selectedGmailDeletion.from ?? '' },
        { label: 'To', value: selectedGmailDeletion.to ?? '' },
        { label: 'Subject', value: selectedGmailDeletion.subject ?? '' },
        {
          label: 'Has the words',
          value: selectedGmailDeletion.hasTheWords ?? '',
        },
        {
          label: 'Doesn’t have',
          value: selectedGmailDeletion.doesntHaveTheWords ?? '',
        },
        {
          label: 'Deletion Type',
          value:
            selectedGmailDeletion.type === 'message'
              ? 'By Message'
              : 'By Thread',
        },
      ],
    },
    {
      title: 'Sources',
      leftItems: [
        {
          value: selectedGmailDeletion.sources?.map((email) => ({
            email: email,
            type: selectedGmailDeletion.sourceType,
          })),
          variant: 'chip',
          flex: true,
          isVisible: Boolean(
            selectedGmailDeletion.sources &&
              selectedGmailDeletion.sources.length > 0
          ),
        },
      ],
    },
  ];

  return <SharedReviewLayout sections={sections} />;
}
